module.exports = __webpack_public_path__ + "static/media/care-professionals.65535d4e.svg";